import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CamService } from 'src/app/services/camService/cam.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CompanyManagementContentService } from '../../services/company-management-content.service';


@Component({
    selector: 'app-successfully-uploaded',
    templateUrl: './successfully-uploaded.component.html',
    styleUrls: ['./successfully-uploaded.component.scss'],
    imports: [MatIconButton, MatIcon, ReactiveFormsModule, FormsModule]
})
export class SuccessfullyUploadedComponent {
  //private _MatDialogRef: any;
  content: any;
  constructor(public dialogRef: MatDialogRef<SuccessfullyUploadedComponent>, private _CamService: CamService, private contentService: CompanyManagementContentService) { }

  CloseDialog(): void {
    this.dialogRef.close();
    this._CamService.notifyDialogClosed(true); 
  }

  ngOnInit(): void {
    this.contentService.content$.subscribe((res: any) => { this.content = res; });
  }

}
